import {useState} from 'react';
import cx from 'clsx';
import {Box, Group, Title} from '@mantine/core';
import classes from './PageNav.module.css';

const links = [
    {label: 'File structure', link: '#file_structure', order: 1},
    {label: 'Jellyfish Arguments', link: '#jellyfish_args', order: 1},
    {label: 'Download Arguments', link: '#download_args', order: 1},
    {label: 'Cutadapt Arguments', link: '#cutadapt_args', order: 1},
    {label: 'CGR Arguments', link: '#cgr_args', order: 1},
    {label: 'File Arguments', link: '#files_args', order: 1},
];

export function ConfigNav() {
    // State to manage the currently active link
    const [active, setActive] = useState('#file_structure');

    // Function to scroll to the section and set the active link
    const scrollToSection = (link: string) => {
        const element = document.querySelector(link);
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
            setActive(link); // Set the active link
        }
    };

    const items = links.map((item) => (
        <Box<'a'>
            component="a"
            href={item.link}
            onClick={(event) => {
                event.preventDefault();
                scrollToSection(item.link);
            }}
            key={item.label}
            className={cx(classes.link, {[classes.linkActive]: active === item.link})}
            style={{paddingLeft: `calc(${item.order} * var(--mantine-spacing-md))`}}
        >
            {item.label}
        </Box>
    ));

    return (
        <Box
            top={136}
            pos='sticky'
            pr='xl'
            w={220}
        >
            <Group mb="md">
                <Title size="h6">ON THIS PAGE</Title>
            </Group>
            {items}
        </Box>
    );
}
